<template>
  <div class="detial-icongroup">
    <div class="category_box">
      <span
        class="text-uppercase world"
        v-if="detailData.categories"
        v-for="item in detailData.categories"
        >{{ item }}</span
      >
    </div>
    <div class="group">
      <span class="v-hidden">
        <a class="tuite" target="_blank" @click="share_twitter"
          ><img src="@/assets/imgs/detial/tuite.png" width="100%" alt=""
        /></a>
      </span>
      <span class="v-hidden">
        <a class="facebook" target="_blank" @click="shareFacebook"
          ><img src="@/assets/imgs/detial/facebook.png" width="100%" alt=""
        /></a>
      </span>
      <span class="v-hidden">
        <a class="sina" target="_blank" @click="shareSina"
          ><img src="@/assets/imgs/detial/sina.png" width="100%" alt=""
        /></a>
      </span>
      <span class="bg-wx">
        <a class="wx" @click="showShare"
          ><img src="@/assets/imgs/share/share_black.png" width="100%" alt=""
        /></a>
      </span>
      <img
        src="@/assets/imgs/share/poster_black.png"
        alt
        class="joker"
        v-if="showPoster"
        @click="showDialog"
      />
      <a class="v-line">|</a>

      <img
        src="@/assets/imgs/detial/like_full.png"
        alt
        class="joker"
        v-if="status == 1"
        @click="setlikeFn(0)"
      />
      <img
        src="@/assets/imgs/detial/like.png"
        alt
        class="joker"
        v-else
        @click="setlikeFn(1)"
      />

      <!-- <span :class="['num', { num1: status == 1 }]">{{ num }}</span> -->
    </div>
  </div>
</template>

<script>
import { setlike, setShareHtml, getShortUrl } from "@/network/details.js";
import { setNewShare } from "@/network/share.js";
export default {
  name: "DetialIconGroup",
  data() {
    return {
      num: 0,
      categoryArr: [],
      status: 0,
      isOk: true,
      postId: "",
      share_title: "",
      share_url: "",
      shareBoxLeft: 0,
      showPoster: true,
      clientWidth: 0,
    };
  },
  props: ["detailData", "postImg"],
  mounted() {
    this.clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    this.showPosterBtn();
    // this.handleArr();
    this.num = this.detailData.numOfLikes;
    this.status = localStorage.getItem(this.detailData.postId);

    // 分享参数
    this.share_title = this.detailData.postTitle;
    this.share_url = window.location.href;
    // alert(this.share_url)
    this.setPosition();

    let meta = document.getElementsByTagName("meta");
    let meta1;
    let meta2;
    let meta3;
    for (let i in meta) {
      if (meta[i].name === "og_image") {
        meta1 = meta[i];
      }
      if (meta[i].name === "og_title") {
        meta2 = meta[i];
      }
      if (meta[i].name === "og_url") {
        meta3 = meta[i];
      }
    }
  },
  methods: {
    showShare() {
      // this.$emit("showshare");
      this.$store.state.showShareModel = true;

      var s_body = document.querySelector("body");

      if (this.$store.state.showShareModel) {
        s_body.style.overflowY = "hidden";
      } else {
        s_body.style.overflowY = "auto";
      }
    },
    setPosition() {
      // console.log( document.body.clientWidth)
      this.shareBoxLeft = (document.body.clientWidth - 600) / 2;
      // alert(this.shareBoxLeft)
    },
    shareSina() {
      let sinaUrl =
        "http://service.weibo.com/share/share.php?appkey=&title=" +
        encodeURIComponent(this.share_title) +
        "&url=" +
        this.share_url;
      window.open(
        sinaUrl,
        "",
        "width=600,height=500,scrollbars=1,left=" +
          this.shareBoxLeft +
          ", top=150"
      );
    },
    share_twitter() {
      let postId = this.detailData.postId;
      setNewShare({
        id: postId,
        website: "twitter",
      }).then((res2) => {
        // console.log(res2, "res2");
        let twitterUrl = res2.data;
        if (this.clientWidth > 750) {
          window.open(
            twitterUrl,
            "",
            "width=600, height=500, left=" + this.shareBoxLeft + ", top=150"
          );
        } else {
          location.href = twitterUrl;
        }
      });
    },
    shareFacebook() {
      let postId = this.detailData.postId;
      setShareHtml({
        id: postId,
        website: "facebook",
      }).then((res) => {
        console.log(res);
        let _uri = res.data;
        if (this.clientWidth > 750) {
          window.open(
            _uri,
            "",
            "width=600, height=500, left=" + this.shareBoxLeft + ", top=150"
          );
        } else {
          location.href = _uri;
        }
      });

      return;
    },

    setlikeFn(nub) {
      if (this.isOk) {
        this.isOk = false;
        this.status = nub;
        //取消点赞
        if (nub == 0) {
          localStorage.removeItem(this.detailData.postId);
        } else {
          //点赞
          localStorage.setItem(this.detailData.postId, nub);
        }
        setlike({ postId: this.detailData.postId, status: this.status })
          .then((res) => {
            if (res.code == 200) {
              this.num = res.data;
            }
            this.isOk = true;
          })
          .catch((res) => {
            this.isOk = true;
          });
      }
    },
    // detailData.categoryName
    showDialog() {
      this.$emit("showDialogFn");
    },
    showWx() {
      this.$emit("showWxFn");
    },
    handleArr() {
      // this.categoryArr = this.detailData.categoryName.split(",");
    },

    showPosterBtn() {
      //  判断是否是移动端打开，显示poster按钮或者不显示
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.showPoster = true;
      } else {
        this.showPoster = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detial-icongroup {
  &::after {
    content: "";
    clear: both;
    display: block;
  }
  // height: 1.5rem;
  padding: 0.3rem 0.4rem;
  line-height: 1.5rem;
  .world {
    background: #222222;
    font-size: 12px;
    color: #fff;
    font-family: Calibri Bold;
    cursor: pointer;
    float: left;
    line-height: 0.3rem;
    margin: 0.05rem;
    // padding: 0.12rem;
    border-radius: 2px;
    padding: 2px 5px 2px 6px;
    letter-spacing: 0.8px;
  }
  .group {
    float: right;
    display: flex;
    align-items: center;
    // padding-top: 0.1rem;
  }
  a {
    float: right;
    height: 0.58rem;
    width: 0.58rem;
    margin: 0 0.08rem;
    cursor: pointer;
    img {
      display: block;
    }
  }

  .facebook {
    // background: url("~@/assets/imgs/detial/facebook.png") no-repeat;
    // background-size: 100% 100%;
  }
  .tuite {
    // background: url("~@/assets/imgs/detial/tuite.png") no-repeat;
    // background-size: 100% 100%;
  }
  .sina {
    // background: url("~@/assets/imgs/detial/sina.png") no-repeat;
    // background-size: 100% 100%;
  }
  .wx {
    // background: url("~@/assets/imgs/detial/weixin.png") no-repeat;
    // background-size: 100% 100%;
    margin: 0 0.3rem;
  }
  .v-line {
    font-size: 0.54rem;
    line-height: 0.48rem;
    text-align: center;
    color: #cccccc;
  }
  .joker {
    float: right;
    height: 0.58rem;
    width: 0.58rem;
    margin: 0 0.1rem;
    cursor: pointer;
  }
  .num {
    float: right;
    font-size: 0.4rem;
    line-height: 0.5rem;
    text-align: center;
    margin: 0 0.1rem;
    color: #676767;
    font-family: OpenSans;
  }
  .num1 {
    float: right;
    color: #936606;
  }
}
@media screen and (min-width: 768px) {
  .group {
    float: right;
    display: flex;
    align-items: center;
    // padding-top: 0.1rem;
    width: 50%;
    .v-hidden {
      visibility: hidden;
    }
  }
}
@media screen and (max-width: 768px) {
  .detial-icongroup {
    .category_box {
      width: 50%;
      float: left;
    }
    .group {
      float: right;
      display: flex;
      align-items: center;
      // padding-top: 0.1rem;
      // width: 50%;
      .v-hidden {
        display: none;
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .detial-icongroup {
    .category_box {
      width: 70%;
      float: left;
    }
    .group {
      float: right;
      // display: flex;
      // align-items: center;
      // padding-top: 0.1rem;
      width: 30%;
      text-align: right;
    }
    padding: 0.3rem 0;
    a {
      width: 0.36rem;
      height: 0.36rem;
    }
    .joker {
      float: right;
      height: 0.36rem;
      width: 0.36rem;
      margin: 0 0.1rem;
      cursor: pointer;
    }
    .num {
      float: right;
      font-size: 0.3rem;
      line-height: 0.21rem;
      text-align: center;
      margin: 0 0.1rem;
      color: #676767;
      font-family: OpenSans;
    }
    .num1 {
      float: right;
      color: #936606;
    }
    .v-line {
      font-size: 0.3rem;
      line-height: 0.3rem;
      text-align: center;
      color: #cccccc;
    }
    .world {
      background: #222222;
      // border-radius: 5px;
      font-size: 0.2rem;
      color: #fff;
      font-family: FranklinGothic-Demi;
      cursor: pointer;
      float: left;
      padding: 1px 2px 1px 6px;
      letter-spacing: 1.5px;
    }
  }
}
</style>
